import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {AuthenticateModalProps} from '@Modals/authenticate-modal/authenticate-modal';
import {GA4EventName, GA4EventParamName, SignupWallShownType, trackGA4CustomEvent} from '@Libraries/ga-events';
import {AUTH_TYPE} from '@Libraries/login-signup-library';
import {getRememberedAuthType} from '@Libraries/requested-auth-view.library';

const DEFAULT_SIGNUP_SOURCE = 'default';

export const openAuthenticateModal = (props: AuthenticateModalProps): void => {
  const initialAuthType = props.initialAuthType ?? getRememberedAuthType();
  trackGA4CustomEvent(GA4EventName.FUNNEL_SIGNUP_WALL_SHOWN, {
    [GA4EventParamName.SOURCE]: props.signupSource ?? DEFAULT_SIGNUP_SOURCE,
    [GA4EventParamName.TYPE]: getSignupWallShownType(initialAuthType),
  });
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AUTHENTICATE_MODAL,
      panelProps: {...props, initialAuthType},
    })
  );
};

const getSignupWallShownType = (authType: AUTH_TYPE | undefined): SignupWallShownType => {
  return authType === AUTH_TYPE.SIGNUP ? SignupWallShownType.SIGNUP : SignupWallShownType.LOGIN;
};
